<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-container fluid class="m-3">
                <b-row>
                    <b-col cols="12">
                        <div class="mb-3">
                            <strong class="text-sm text-md-md text-lg-lg">
                                BY CLICKING THE BOX AT THE END OF THIS DOCUMENT INDICATING YOUR ACCEPTANCE (THE “ACCEPTANCE”) OF THIS ENROLLMENT CONTRACT (THIS “AGREEMENT”), YOU AGREE YOU HAVE READ AND ARE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE WITH THIS AGREEMENT, YOU MUST NOT ACCEPT THIS AGREEMENT AND MUST NOT CONTINUE WITH THE COURSE REGISTRATION. DOING SO MEANS YOU START AN OFFICIAL WITHDRAWAL PROCESS. IF YOU ACCEPT THIS AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND ARE BOUND BY, THE TERMS AND CONDITIONS STATED HEREIN.
                            </strong>
                        </div>

                        <div class="mb-4">
                            <p>This Agreement is by and between you and BAY ATLANTIC UNIVERSITY (the “BAU”) and is effective as of the date of Acceptance (the “Effective Date”). It governs your academic and financial rights and responsibilities. BAU reserves the right to change or modify portions of this Agreement at any time, effective during the next semester’s course registration. You will be asked to sign the Agreement for each semester you are enrolled at BAU.</p>
                            <strong class="text-sm text-md-md text-lg-lg">
                                This Agreement Covers the Following Current Period of Attendance for the Program:<br>
                                Period of Attendance Start Date: {{form.education_start_date || '______________'}} Period of Attendance End Date: {{form.education_end_date || '______________'}}
                            </strong>
                            <p class="font-italic text-muted small mt-1">Semester start and end dates will be entered here</p>
                            <p>This Agreement covers only the above-referenced current period of attendance for the Program. If the number of semesters to complete the Program extends beyond the above-referenced period of attendance end date, as a condition to further enrollment, you will be required to execute a new Enrollment Agreement with BAU to cover the then-current period of attendance for the Program.</p>
                        </div>

                        <div>
                            <p class="font-weight-bold">A. VERIFICATION OF PERSONAL INFORMATION</p>
                            <p>The following information is pulled from the application form you submitted. If you need to update the information, you can click on the Edit Button. (Only after this section, there will be an edit section and then the student will verify the edited version).</p>
                        </div>

                        <b-row class="d-flex">
                            <!-- Personal Information -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card :title="$t('Your Personal Information')" class="h-100">
                                    <b-col cols="12">
                                        <b-form-group :label="$t('name')">
                                            <b-form-input v-model="form.name" :disabled="true"/>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group :label="$t('middle_name')">
                                            <b-form-input v-model="form.middle_name" :disabled="true" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group :label="$t('last_name')">
                                            <b-form-input v-model="form.surname" :disabled="true" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                                            <b-form-group :label="$t('date_of_birth')">
                                                <select-date v-model="form.birthdate"/>
                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group :label="$t('legal_presence_type')">
                                            <parameter-selectbox
                                                :disabled="true"
                                                code="legal_presence_types"
                                                v-model="form.legal_presence_type"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- US Address -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card :title="$t('Your Mailing U.S.Address')" class="h-100">
                                    <b-col cols="12">
                                        <b-form-group :label="$t('Search your US Address')">
                                            <AddressSearchComponent
                                                v-model="searchAddress"
                                                @selectedAddress="selected"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="contact_address" rules="" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('address')">
                                                <b-form-input
                                                    type="text"
                                                    v-model="form.contact_address"
                                                    :state="errors[0] ? false : valid ? true : null"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="contact_state_id" rules="" v-slot="{ errors }">
                                            <b-form-group :label="$t('state')">
                                                <state-selectbox
                                                    :validateError="errors[0]"
                                                    v-model="form.contact_state_id"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="contact_city_id" rules="" v-slot="{ errors }">
                                            <b-form-group :label="$t('city')">
                                                <city-selectbox
                                                    v-model="form.contact_city_id"
                                                    :state_id="form.contact_state_id"
                                                    :validateError="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-row>
                                            <b-col cols="12" sm="6">
                                                <b-form-group :label="$t('apartment')">
                                                    <b-form-input type="text" v-model="form.apartment"/>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="6">
                                                <b-form-group :label="$t('zip_code')">
                                                    <b-form-input v-model="form.contact_zip_code"/>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Home Address -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card :title="$t('Your Home Address')" class="h-100">
                                    <b-col cols="12">
                                        <b-form-group :label="$t('country')">
                                            <country-selectbox v-model="form.address_country_id"/>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group :label="$t('address')">
                                            <b-form-input type="text" v-model="form.address"/>
                                        </b-form-group>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Contact Information -->
                            <b-col cols="12" md="6" lg="6" class="mb-3">
                                <b-card :title="$t('contact_information')" class="h-100">
                                    <b-col cols="12">
                                        <ValidationProvider name="personal_email" rules="required|email" v-slot="{ errors }">
                                            <b-form-group :label="$t('personal_email')">
                                                <b-form-input v-model="form.personal_email"/>
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                                            <b-form-group label="Your U.S. Mobile Phone">
                                                <PhoneNumberInput
                                                    v-model="mobile_tel"
                                                    :validate-error="errors[0]"
                                                    :defaultCountryCode="form.countryCodeForm"
                                                    @update="mobileTelUpdated"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group label="Other Phone">
                                            <b-form-input v-model="form.other_phone"/>
                                        </b-form-group>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Emergency Contact -->
                            <b-col cols="12" md="6" lg="6" class="mb-3">
                                <b-card title="Emergency Contact" class="h-100">
                                    <b-col cols="12">
                                        <ValidationProvider name="emergency_person_name" rules="required" v-slot="{ errors }">
                                            <b-form-group label="Emergency Contact Name">
                                                <b-form-input v-model="form.emergency_person_name"/>
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="emergency_person_relation" rules="required" v-slot="{ errors }">
                                            <b-form-group label="Emergency Contact Relationship to You">
                                                <b-form-input v-model="form.emergency_person_relation"/>
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider name="emergency_person_phone" rules="required" v-slot="{ errors }">
                                            <b-form-group label="Emergency Contact Telephone Number">
                                                <PhoneNumberInput
                                                    v-model="emergency_person_phone"
                                                    :validate-error="errors[0]"
                                                    :defaultCountryCode="form.countryCodeFormEmergency"
                                                    @update="emergencyPersonPhoneUpdated"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                            <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                                <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                    <div class="d-flex flex-row-reverse">
                                        <b-form-checkbox
                                            id="checkbox-dual-a"
                                            v-model="form.status"
                                            name="checkbox-dual-a"
                                            value="accepted"
                                            :unchecked-value="null"
                                            class="text-sm text-md-md ml-4"
                                        />
                                        <div>
                                            I confirm that the information given in this section is true, complete, and accurate
                                        </div>
                                    </div>
                                    <b-form-invalid-feedback v-if="errors[0]">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4" class="text-md-right mt-3">
                                <b-button
                                    type="submit"
                                    @click="next"
                                    variant="primary"
                                    class="w-100 w-md-auto"
                                >
                                    {{ $t('next') }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </ValidationObserver>
    </div>
</template>
<script>
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import StateSelectbox from "@/components/interactive-fields/StateSelectbox.vue";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
import SelectDate from "@/components/interactive-fields/SelectDate.vue";
import PhoneNumberInput from "@/components/elements/PhoneNumberInput.vue";
import AddressSearchComponent from "@/components/interactive-fields/AddressSearchComponent.vue";

export default {
    components: {
        AddressSearchComponent,
        PhoneNumberInput,
        SelectDate,
        ParameterSelectbox,
        CountrySelectbox,
        CitySelectbox,
        StateSelectbox
    },
    data() {
        return {
            form: {
                status: null,
            },
            searchAddress: null,
            mobile_tel: null,
            emergency_person_phone: null,
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            let user = await JSON.parse(localStorage.getItem('user'));
            const response = await EnrollmentAgreementForm.getStudentInformation(user.active_student_program.id)
            this.form = response.data.data
            this.mobile_tel = (this.form.mobile_tel_country_code ?? '') + (this.form.mobile_tel ?? '')
            this.emergency_person_phone = (this.form.emergency_person_phone_country_code ?? '') + (this.form.emergency_person_phone ?? '')
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                await this.$store.dispatch('enrollmentAgreementForm/saveFormData', this.form);
                this.$emit('next', 1)
            }
        },
        mobileTelUpdated(event) {
            this.form.mobile_tel = event.nationalNumber;
            this.form.mobile_tel_country_code = '+' + event.countryCallingCode
        },
        emergencyPersonPhoneUpdated(event) {
            this.form.emergency_person_phone = event.nationalNumber;
            this.form.emergency_person_phone_country_code = '+' + event.countryCallingCode
        },
        selected(address) {
            this.form.contact_address = address.address
            this.form.contact_state_id = address.state_id
            this.form.contact_city_id = address.city_id
            this.form.contact_zip_code = address.zip_code
        }
    }
}
</script>
